import classnames from 'classnames';
import React, { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { ActionClickOrigin } from '../../../../../utils/hooks/bi/useTrackActions/useTrackActions.types';
import { Button, ItemActionsRow } from '../../../../common';
import { ActionButton } from '../../../../common/ItemActionsRow/ItemActionsRow.types';
import { LinkSmall } from '../../../../common/WixIcons';
import styles from './BoardActionsRow.scss';
import { IOuter } from './BoardActionsRow.types';
import { Tooltip } from '@wix/design-system';

const buttons = [ActionButton.More];
export const BoardActionsRow: FC<IOuter> = ({
  className,
  isAvailableOnAllSites,
  onOpenContextMenu,
  item,
  currentFolder,
  onOpenButtonClick,
}) => {
  const handleOpenClick = useCallback(
    (event) => {
      onOpenButtonClick(item, event);
    },
    [onOpenButtonClick, item],
  );

  return (
    <div className={classnames(styles.actionsRow, className)}>
      <ItemActionsRow
        className={styles.rowEnd}
        onThreeDotsClick={onOpenContextMenu}
        item={item}
        buttons={buttons}
        currentFolder={currentFolder}
        actionsClickOrigin={ActionClickOrigin.File}
      />

      <div className={styles.rowStart}>
        {isAvailableOnAllSites && (
          <Tooltip
            dataHook="tooltip-board-all-sites"
            content={<FormattedMessage id="boards.board-available-on-all-sites" />}
            placement="top"
            appendTo="viewport"
          >
            <div className={styles.availableOnAllSites}>
              <LinkSmall />
            </div>
          </Tooltip>
        )}
      </div>

      <div className={styles.openButton}>
        <Button size="tiny" onClick={handleOpenClick} dataHook="board-open-button">
          <FormattedMessage id="common.open" />
        </Button>
      </div>
    </div>
  );
};
